import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { authenticatedRoute } from '@/app/routes/authenticated'

export const dashboardRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/',
  // Páginas de módulo são carregadas sob demanda (code splitting por rota).
  component: lazyRouteComponent(() => import('./pages/dashboard-page'), 'DashboardPage'),
})
